(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["affiliate-programme"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- Smooth scroll that accounts for a sticky header ---------- */
    function headerOffset() {
      var header = document.querySelector('.shopify-section-header-sticky, sticky-header, .section-header, header');
      if (!header) return 16;
      var pos = getComputedStyle(header).position;
      var stuck = pos === 'sticky' || pos === 'fixed' ||
        (header.parentElement && /sticky|fixed/.test(getComputedStyle(header.parentElement).position));
      return (stuck ? header.getBoundingClientRect().height : 0) + 16;
    }

    function scrollToTarget(target, focusFirst) {
      if (!target) return;
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
      window.scrollTo({ top: Math.max(top, 0), behavior: reduceMotion ? 'auto' : 'smooth' });
      if (!focusFirst) return;
      var field = target.querySelector('.aff__field input') || target.querySelector('.aff__success');
      if (!field) return;
      var done = false;
      var focus = function () { if (done) return; done = true; field.focus({ preventScroll: true }); };
      if ('onscrollend' in window && !reduceMotion) window.addEventListener('scrollend', focus, { once: true });
      setTimeout(focus, reduceMotion ? 0 : 900);
    }

    /* ---------- Stepper ---------- */
    function initStepper(root) {
      var stepper = root.querySelector('[data-aff-stepper]');
      if (!stepper) return;
      var tabs = Array.prototype.slice.call(stepper.querySelectorAll('[data-aff-step-tab]'));
      var panels = Array.prototype.slice.call(stepper.querySelectorAll('[data-aff-step-panel]'));
      var prev = stepper.querySelector('[data-aff-prev]');
      var next = stepper.querySelector('[data-aff-next]');
      var finish = stepper.querySelector('[data-aff-finish]');
      var countEl = stepper.querySelector('[data-aff-step-count]');
      var bar = stepper.querySelector('[data-aff-step-bar]');
      var total = panels.length;
      var current = 0;

      function show(index, focusTab) {
        current = Math.max(0, Math.min(index, total - 1));
        panels.forEach(function (p, i) {
          var on = i === current;
          p.hidden = !on;
          p.classList.toggle('is-entering', on);
        });
        tabs.forEach(function (t, i) {
          var on = i === current;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        if (countEl) countEl.textContent = 'Step ' + (current + 1) + ' of ' + total;
        if (bar) bar.style.width = ((current + 1) / total) * 100 + '%';
        if (prev) prev.disabled = current === 0;
        var last = current === total - 1;
        if (next) next.hidden = last;
        if (finish) finish.hidden = !last;
        if (focusTab) tabs[current].focus();
        if (tabs[current].scrollIntoView && window.innerWidth < 750) {
          tabs[current].scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
        t.addEventListener('keydown', function (e) {
          var keys = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 };
          if (keys[e.key]) { e.preventDefault(); show((current + keys[e.key] + total) % total, true); }
          else if (e.key === 'Home') { e.preventDefault(); show(0, true); }
          else if (e.key === 'End') { e.preventDefault(); show(total - 1, true); }
        });
      });
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });

      // Theme editor: selecting a step block shows it
      root.addEventListener('shopify:block:select', function (e) {
        var i = panels.indexOf(e.target);
        if (i > -1) show(i);
      });

      show(0);
    }

    /* ---------- Form ---------- */
    function initForm(root) {
      var form = document.getElementById(root.dataset.formId);
      if (!form || form.querySelector('[data-aff-success-static]')) {
        if (form && form.querySelector('[data-aff-success-static]') && !location.hash) {
          scrollToTarget(document.getElementById(root.dataset.anchor), false);
        }
        return;
      }

      form.noValidate = true;
      var submit = form.querySelector('[data-aff-submit]');
      var submitLabel = form.querySelector('[data-aff-submit-label]');
      var errorsBox = form.querySelector('[data-aff-errors]');
      var tpl = root.querySelector('[data-aff-success-tpl]');
      var sending = false;
      var nativeSubmit = false;

      function fieldError(input) {
        var err = document.getElementById(input.getAttribute('aria-describedby'));
        var ok = input.checkValidity();
        input.setAttribute('aria-invalid', ok ? 'false' : 'true');
        if (err) err.textContent = ok ? '' : err.dataset.msg;
        return ok;
      }

      function validate() {
        var firstBad = null;
        form.querySelectorAll('input[required], input[pattern]').forEach(function (input) {
          if (input.value === '' && !input.required) { fieldError(input); return; }
          if (!fieldError(input) && !firstBad) firstBad = input;
        });
        if (firstBad) firstBad.focus();
        return !firstBad;
      }

      form.querySelectorAll('input[required], input[pattern]').forEach(function (input) {
        input.addEventListener('blur', function () { if (input.value !== '' || input.type === 'checkbox') fieldError(input); });
        input.addEventListener('input', function () { if (input.getAttribute('aria-invalid') === 'true') fieldError(input); });
        input.addEventListener('change', function () { if (input.type === 'checkbox') fieldError(input); });
      });

      function setBusy(busy) {
        sending = busy;
        submit.disabled = busy;
        submit.setAttribute('aria-busy', busy ? 'true' : 'false');
        if (submitLabel) {
          if (!submitLabel.dataset.idle) submitLabel.dataset.idle = submitLabel.textContent;
          submitLabel.textContent = busy ? 'Sending...' : submitLabel.dataset.idle;
        }
      }

      function showErrors(html) {
        errorsBox.innerHTML = html || 'Something went wrong. Please try again.';
        errorsBox.hidden = false;
        errorsBox.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      function showSuccess(data) {
        form.innerHTML = '';
        form.appendChild(tpl.content.cloneNode(true));
        var box = form.querySelector('.aff__success');
        if (box) box.focus({ preventScroll: true });

        // Analytics hooks
        var detail = { email: data.email, marketing: data.marketing };
        root.dispatchEvent(new CustomEvent('affiliate:submitted', { bubbles: true, detail: detail }));
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('affiliate_signup', { marketing: data.marketing }); } catch (e) {}
        if (window.dataLayer) window.dataLayer.push({ event: 'affiliate_signup' });
      }

      function value(selector) {
        var el = form.querySelector(selector);
        return el ? el.value.trim() : '';
      }

      /* Optional: also create a tagged customer (only with marketing consent) */
      function createCustomer(data) {
        if (root.dataset.createCustomer !== 'true' || !data.marketing) return Promise.resolve();
        var parts = data.name.split(' ');
        var body = new URLSearchParams();
        body.append('form_type', 'customer');
        body.append('utf8', String.fromCharCode(10003));
        body.append('contact[email]', data.email);
        body.append('contact[first_name]', parts.shift() || '');
        body.append('contact[last_name]', parts.join(' '));
        body.append('contact[tags]', root.dataset.customerTags || 'affiliate-applicant');
        return fetch('/contact#contact_form', { method: 'POST', body: body, credentials: 'same-origin' }).catch(function () {});
      }

      /* Optional: send a copy to a webhook (Google Apps Script, Zapier, Make...) */
      function sendWebhook(data) {
        var url = root.dataset.webhook;
        if (!url) return;
        try {
          fetch(url, {
            method: 'POST',
            mode: 'no-cors',
            keepalive: true,
            headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
            body: JSON.stringify(data)
          }).catch(function () {});
        } catch (e) {}
      }

      form.addEventListener('submit', function (e) {
        if (nativeSubmit) return;
        e.preventDefault();
        if (sending) return;
        errorsBox.hidden = true;
        if (!validate()) return;

        var mkt = form.querySelector('[data-aff-marketing]');
        var data = {
          name: value('[name="contact[name]"]'),
          email: value('[name="contact[email]"]'),
          phone: value('[name="contact[phone]"]'),
          marketing: !!(mkt && mkt.checked),
          page: window.location.href,
          submitted_at: new Date().toISOString()
        };

        // Bots fill the hidden field: pretend it worked, send nothing.
        var hp = form.querySelector('[data-aff-hp]');
        if (hp && hp.value) { showSuccess(data); return; }

        setBusy(true);
        fetch(form.action, {
          method: 'POST',
          body: new URLSearchParams(new FormData(form)),
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        })
          .then(function (res) {
            // Shopify asked for a captcha: fall back to a normal submit so the shopper can complete it.
            if (/\/challenge/.test(res.url)) {
              nativeSubmit = true;
              form.submit();
              return null;
            }
            return res.text().then(function (html) { return { res: res, html: html }; });
          })
          .then(function (out) {
            if (!out) return;
            var doc = new DOMParser().parseFromString(out.html, 'text/html');
            var returned = doc.getElementById(form.id);
            var errs = returned && returned.querySelector('[data-aff-errors]:not([hidden])');
            var ok = /contact_posted=true/.test(out.res.url) || (returned && returned.querySelector('[data-aff-success-static]'));

            if (ok || (out.res.ok && !errs)) {
              sendWebhook(data);
              return createCustomer(data).then(function () { showSuccess(data); });
            }
            setBusy(false);
            showErrors(errs ? errs.innerHTML : null);
          })
          .catch(function () {
            setBusy(false);
            showErrors('We could not send your application. Please check your connection and try again.');
          });
      });
    }

    /* ---------- CTA scroll ---------- */
    function initCtas(root) {
      root.addEventListener('click', function (e) {
        var link = e.target.closest('[data-aff-scroll]');
        if (!link) return;
        var id = (link.getAttribute('href') || '').replace(/^.*#/, '');
        var target = id && document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        var isForm = id === root.dataset.anchor;
        scrollToTarget(target, isForm);
        if (history.replaceState) history.replaceState(history.state, '', '#' + id);
      });

      // Arriving from another page via /pages/affiliate#join
      if (location.hash === '#' + root.dataset.anchor) {
        var target = document.getElementById(root.dataset.anchor);
        window.addEventListener('load', function () { scrollToTarget(target, false); }, { once: true });
      }
    }

    function init(root) {
      if (!root || root.dataset.affReady) return;
      root.dataset.affReady = 'true';
      initCtas(root);
      initStepper(root);
      initForm(root);
    }

    function initAll(scope) { (scope || document).querySelectorAll('[data-aff]').forEach(init); }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('product-video-banner')) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class ProductVideoBanner extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.mode = this.dataset.mode === 'player' ? 'player' : 'banner';
        this.video = this.querySelector('video');
        this.embed = this.querySelector('[data-embed]');
        this.toggleBtn = this.querySelector('[data-pvb-toggle]');
        this.muteBtn = this.querySelector('[data-pvb-mute]');
        this.startBtn = this.querySelector('[data-pvb-start]');
        this.userPaused = false;

        if (this.video) {
          this.video.muted = true;
          this.video.playsInline = true;
          this.video.setAttribute('playsinline', '');
          this.video.removeAttribute('autoplay');
        }

        var autoplay = this.mode === 'banner' && this.dataset.autoplay !== 'false' && !reduceMotion;

        if (autoplay) {
          this.watchVisibility();
        } else {
          this.classList.add('show-play', 'is-paused');
        }

        var self = this;
        if (this.startBtn) this.startBtn.addEventListener('click', function () { self.start(); });
        if (this.toggleBtn) this.toggleBtn.addEventListener('click', function () { self.toggle(); });
        if (this.muteBtn) this.muteBtn.addEventListener('click', function () { self.toggleMute(); });

        if (this.video) {
          this.video.addEventListener('play', function () { self.setPaused(false); });
          this.video.addEventListener('pause', function () { self.setPaused(true); });
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      /* Autoplay only while on screen: saves data and battery */
      watchVisibility() {
        var self = this;
        if (!('IntersectionObserver' in window)) { this.play(); return; }
        this.observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (!self.userPaused) self.play();
            } else {
              self.pause(true);
            }
          });
        }, { threshold: 0.25 });
        this.observer.observe(this);
      }

      loadEmbed(src) {
        if (!this.embed) return;
        var frame = this.embed.querySelector('iframe');
        if (frame && frame.dataset.src === src) return;
        this.embed.innerHTML = '';
        frame = document.createElement('iframe');
        frame.src = src;
        frame.dataset.src = src;
        frame.title = this.embed.dataset.title || 'Product video';
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.setAttribute('allowfullscreen', '');
        this.embed.appendChild(frame);
      }

      play() {
        if (this.video) {
          var p = this.video.play();
          if (p && p.catch) {
            var self = this;
            p.catch(function () { self.classList.add('show-play', 'is-paused'); });
          }
        } else if (this.embed) {
          this.loadEmbed(this.embed.dataset.srcBg);
          this.setPaused(false);
        }
      }

      pause(auto) {
        if (this.video) this.video.pause();
        else if (this.embed && !auto) { this.embed.innerHTML = ''; this.setPaused(true); }
      }

      toggle() {
        var paused = this.classList.contains('is-paused');
        this.userPaused = !paused;
        if (paused) this.play(); else this.pause(false);
      }

      toggleMute() {
        if (!this.video) return;
        this.video.muted = !this.video.muted;
        this.classList.toggle('is-unmuted', !this.video.muted);
        this.muteBtn.setAttribute('aria-pressed', String(!this.video.muted));
        this.muteBtn.setAttribute('aria-label', this.video.muted ? 'Unmute video' : 'Mute video');
      }

      /* Big play button: plays with sound and controls */
      start() {
        this.classList.remove('show-play');
        this.classList.add('is-started');
        this.userPaused = false;
        if (this.video) {
          this.video.muted = false;
          this.video.controls = true;
          this.classList.add('is-unmuted');
          this.video.play();
          this.video.focus();
        } else if (this.embed) {
          this.loadEmbed(this.embed.dataset.srcPlay);
          this.embed.style.pointerEvents = 'auto';
          var frame = this.embed.querySelector('iframe');
          if (frame) frame.style.pointerEvents = 'auto';
        }
      }

      setPaused(paused) {
        this.classList.toggle('is-paused', paused);
        if (this.toggleBtn) this.toggleBtn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      }
    }

    customElements.define('product-video-banner', ProductVideoBanner);
  })();

  } catch(e) { console.error(e); }
})();
})();
